import { z } from "zod";

// SubSchemas //
export const countrySchema = z.object({
	abbreviation: z.string(),
	name: z.string(),
});

export const stateSchema = z.object({
	id: z.string(),
	abbreviation: z.string(),
	countryCode: z.string(),
	country: countrySchema,
	name: z.string(),
});

export const citySchema = z.object({
	name: z.string(),
	stateId: z.string(),
	state: stateSchema,
	type: z.string().nullable(), // TODO: This might be an enum
});

export const locationSchema = z.object({
	postalCode: z.string(),
	city: z.string(),
	state: z.string(),
	country: z.string(),
});

// GET Request Schemas //
// Endpoint: /api/create-quote/states
export const stateAndCountrySchema = z.object({
	id: z.string(),
	abbreviation: z.string(),
	countryCode: z.string(),
	country: countrySchema,
	name: z.string(),
});
//Endpoint: /api/create-quote/v2/postal-codes?postalCode={:userInput}&countries={country}
export const zipCodeSchema = z.object({
	id: z.string(),
	postalCode: z.string(),
	latitude: z.number().nullable(),
	longitude: z.number().nullable(),
	city: citySchema,
	selectablePostalCode: z.string().optional(),
});

export const addressSchema = stateAndCountrySchema.extend({
	name: z.string().nullable(),
	address1: z.string().nullable(),
	address2: z.string().nullable(),
});

export type LocationState = z.infer<typeof stateAndCountrySchema>;
export type City = z.infer<typeof citySchema>;
export type ZipCode = z.infer<typeof zipCodeSchema>;
export type Country = z.infer<typeof countrySchema>;
